import React from 'react';
import { Button, Question } from 'shared/_ui';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { CONTROL_IDS } from 'shared/consts';
import { useStoreUiControls } from 'shared/lib';

const Faq: React.FC = () => {
  const { t } = useTranslation();
  const { open: openGuide } = useStoreUiControls(CONTROL_IDS.HOW_IT_WORKS_MODAL);

  return (
      <Button
        onClick={openGuide}
        className={styles.button}
        type="text"
        shape="round"
        size="large"
        icon={<Question className={styles.question} />}
      >
        {t('navigation.faq')}
      </Button>
  );
};

export { Faq };
